import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import style from './index.less';
import classNames from 'classnames';

const { Content } = Layout;

const PublicLayout = ({ children }) => {
  return (
    <Layout className="h-full">
      <Content className={classNames(style.mainLayout, 'mt-0')}>
        {children}
      </Content>
    </Layout>
  );
};

export default memo(PublicLayout);

PublicLayout.propTypes = {
  children: PropTypes.any
};
